import { AfterViewInit, Component, Inject, OnInit, ViewChild, ViewEncapsulation } from "@angular/core"
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog"
import { MatInput } from "@angular/material/input"
import { DateOptions, TrDateFilter, TrFilterDialogData, TrSelectFilter } from "../models/models"

@Component({
  selector: "tr-filter-dialog",
  templateUrl: "tr-filter-dialog.component.html",
  styleUrls: ["tr-filter-dialog.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class TrFilterDialogComponent<T> implements AfterViewInit, OnInit {
  public result: string | TrSelectFilter | TrDateFilter | boolean
  public dateType: DateOptions | "" = "equalTo"
  public clearAllOption = "<Clear All>"

  @ViewChild(MatInput, {static: true}) public input: MatInput

  constructor(
    public dialogRef: MatDialogRef<TrFilterDialogComponent<T>>,
    @Inject(MAT_DIALOG_DATA) public dialogData: TrFilterDialogData,
  ) {}

  public ngOnInit(): void {
    this.setDefaults()
  }

  public async ngAfterViewInit(): Promise<void> {
    if (this.dialogData.filterType === "input") {
      setTimeout(() => {
        if (this.input) {
          this.input.focus()
        }
      }, 1)
    }
  }

  public clear(): void {
    switch (this.dialogData.filterType) {
    case "checkbox":
      this.result = null
      break
    case "input":
      this.result = null
      break
    case "dropdown":
      this.result = { singleValue: "", selections: [], isAll: this.dialogData.enableSelectAll }
      break
    case "date":
      this.result = {}
      this.dateType = ""
      break
    }

    this.dialogRef.close(this.result)
  }

  public apply(): void {
    if (this.dialogData.filterType === "input") {
      if (this.result === "") {
        this.result = null
      }
    } else if (this.dialogData.filterType === "checkbox") {
      if (this.result === true) {
        this.result = this.dialogData.checkboxTrueValue
      } else {
        if (this.result !== null) {
          this.result = this.dialogData.checkboxFalseValue
        }
      }

    }

    this.dialogRef.close(this.result)
  }

  public onDateTypeChange(event: DateOptions): void {
    if (event === "between") {
      this.result = {
        [event]: {
          after: new Date(),
          before: new Date(),
          inclusive: false,
        },
      }
    } else {
      this.result = { [event]: this.result[event] || new Date() } as TrDateFilter
    }
    this.dateType = event
  }

  public onSingleSelectionChange(value: string): void {
    let result = this.result as TrSelectFilter
    if (!result || !result.singleValue) {
      result = { singleValue: "", selections: [], isAll: this.dialogData.enableSelectAll }
    }

    result.singleValue = value

    this.result = result
  }

  public onMultipleSelectionChange(event: string[]): void {
    let result = this.result as TrSelectFilter
    if (!result || !result.selections) {
      result = { singleValue: "", selections: [], isAll: this.dialogData.enableSelectAll }
    }

    result.selections = event
    this.result = result
  }

  public clearDateOptions(): void {
    this.result = {}
    this.dateType = ""
  }

  private setDefaults(): void {
    const noOptions = !this.dialogData.selectOptions || this.dialogData.selectOptions.length === 0

    this.result = this.dialogData.defaultValue

    if (this.dialogData.filterType === "dropdown") {
      if (noOptions) {
        throw new Error("No options were found for tr-filter-header, where filterType='dropdown'. Be sure to include the filterOptions available.")
      }

      if (!this.result || Object.keys(this.result).length === 0) {
        this.result = { singleValue: "", selections: [], isAll: this.dialogData.enableSelectAll }
      }
    }

    if (this.dialogData.filterType === "date") {
      this.result = this.result || {}
      const dateOptionsSelected = Object.keys(this.result)
      if (dateOptionsSelected.length > 0) {
        this.dateType = dateOptionsSelected[0] as DateOptions
      }
    }
  }
}
